import {
	GetBaseSearchServiceResponse,
	GetBaseSearchServiceResponseCsv,
	InternalApiSearchServiceOptions,
	SearchServiceOptionsCsv,
} from "@performyard/service-contracts";

import request from "./internal-base-request";

export const getInteralApiSearchService = async (
	params: InternalApiSearchServiceOptions
): Promise<GetBaseSearchServiceResponse> => {
	const urlParams = new URLSearchParams();

	const { service, filters, skip, limit, sort } = params;

	const baseURL = `/v1/search`;

	urlParams.append("service", service);

	if (filters) {
		Object.keys(filters).forEach((key) => {
			const value = Array.isArray(filters[key]) ? filters[key].join(",") : filters[key];
			urlParams.append(key, value);
		});
	}

	if (skip) {
		urlParams.append("skip", skip.toString());
	}

	if (limit) {
		urlParams.append("limit", limit.toString());
	}

	if (sort) {
		urlParams.append("sort", `${sort.direction}(${sort.name})`);
	}

	const url = `${baseURL}?${urlParams.toString()}`;

	const [response] = await request<GetBaseSearchServiceResponse>(url, {
		method: "GET",
	});

	if (response.errors.length) {
		throw new Error("Error fetching results from search service");
	}

	return response;
};

export const getInteralApiSearchServiceCsv = async (
	params: SearchServiceOptionsCsv
): Promise<GetBaseSearchServiceResponseCsv> => {
	const urlParams = new URLSearchParams();

	const { service, filters, sort, columns, fileName } = params;

	const baseURL = `/v1/search`;

	urlParams.append("service", service);

	if (filters) {
		Object.keys(filters).forEach((key) => {
			const value = Array.isArray(filters[key]) ? filters[key].join(",") : filters[key];
			urlParams.append(key, value);
		});
	}

	if (sort) {
		urlParams.append("sort", `${sort.direction}(${sort.name})`);
	}

	if (columns) {
		urlParams.append("columns", columns.join(","));
	}

	if (fileName) {
		urlParams.append("fileName", fileName);
	}

	const url = `${baseURL}/csv?${urlParams.toString()}`;

	const [response] = await request<GetBaseSearchServiceResponseCsv>(url, {
		method: "GET",
	});

	if (response.errors.length) {
		throw new Error("Error fetching results from search service");
	}

	return response;
};
